import { Stack } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { StyledTypography } from './styles.css';

type Props = {
  sx?: any;
  inputSx?: any;
  labelSx?: any;
  placeholder?: string;
  label: string;
  value: any;
  onChange: (value: any) => void;
}

function InputTime(props: Props) {

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction={"row"} mt={2} sx={props.sx}>
        <StyledTypography style={props.labelSx} >{props.label}</StyledTypography>
        <Stack sx={{flex: 1}}>
          <DemoContainer components={['TimePicker']}>
            <TimePicker  slotProps={{
                textField: {
                  sx: props.inputSx
                }
              }} value={props.value} onChange={props.onChange}/>
          </DemoContainer>
        </Stack>
      </Stack>
    </LocalizationProvider>
  );
}

export default InputTime;